<template>
  <view class="content">
    <u--form ref="accessForm"  :model="form" :rules="rules" labelPosition="left" labelWidth="90">
      <view class="title">预约公司信息</view>
      <view class="container">
        <u-form-item   label="公司" prop="uName" @click="showUid = true;">
          <u--input v-model="form.uName" border="none" disabled disabledColor="#ffffff" placeholder="请选择公司"></u--input>
          <u-icon slot="right" name="arrow-right"></u-icon>
        </u-form-item>
      </view>
      <view class="title">预约时间</view>
      <view class="container">
        <u-form-item   label="预约时间" prop="time" @click="showStartTime = true; ">
          <u--input v-model="form.time" border="none" disabled disabledColor="#ffffff" placeholder="请选择入场时间"></u--input>
          <u-icon slot="right" name="arrow-right"></u-icon>
        </u-form-item>
      </view>
      <view class="title">预约人信息</view>
      <view class="container">
        <u-form-item  borderBottom label="来访是由" prop="reasons" >
          <u--input v-model="form.reasons" border="none" disabled disabledColor="#ffffff" placeholder="请选择来访是由"></u--input>
          <u-icon slot="right" name="arrow-right"></u-icon>
        </u-form-item>
        <u-form-item  borderBottom label="访客姓名" prop="vname">
          <u--input
              v-model="form.vname" placeholder="请输入访客姓名"
              border="none"
          ></u--input>
        </u-form-item>
        <u-form-item  borderBottom label="联系电话" prop="vtel" >
          <u--input
              v-model="form.vtel"  placeholder="请输入联系电话"
              border="none"
          ></u--input>
        </u-form-item>

        <u-form-item  borderBottom label="身份证号码" prop="vidNum">
          <u--input
              v-model="form.vidNum" placeholder="请输入身份证号码"
              border="none"
          ></u--input>
        </u-form-item>
        <u-form-item   label="车牌" prop="vcarNum" >
          <u--input
              v-model="form.vcarNum" placeholder="请输入车牌"
              border="none"
          ></u--input>
        </u-form-item>
      </view>
    </u--form>
    <view style="margin-top: 50px;margin-bottom: 50px">
      <u-button @click="submit" shape="circle" type="primary">提交</u-button>
    </view>
    <u-calendar :show="showStartTime" mode="single" @confirm="confirmStartTime" @cancel="showStartTime = false"></u-calendar>
    <u-popup  :show="showUid" mode="bottom" length="80%" @close="close"  :closeable="true"  @open="open">
      <view style="height: 80vh">
        <text class="box-title">请选择公司</text>
        <scroll-view scroll-y class="scroll-container"  :scroll-into-view="toView"  @scrolltolower="lower">
          <view>
            <view class="maItem keyWordInput">
              <u-input v-model="queryParams.deptName" :type="'text'" :border="false" placeholder="请输入公司名称" height="96" @input="searchMan" />
            </view>
            <view class="bodyItem">
                <view v-for="(dataItem,cindex) in indexList"
                      :key="cindex" class="maItem"
                      :class="dataItem.checked?'active':''"
                      @click="clickKSDataItem(dataItem)" >
                  {{dataItem.deptName}}{{dataItem.checked?'active':''}}
                </view>
              <view class="u-m-t-20 bg-fff u-p-b-20" style="margin-top: 20px;padding-bottom: 20px">
                <u-loadmore :status="load.status" color="#999999" :icon-type="load.icon" :load-text="load.text"></u-loadmore>
              </view>
            </view>
          </view>
        </scroll-view>
      </view>
    </u-popup>
    <u-modal :show="show" title="温馨提示" content='提交预约成功！请等待审核' @confirm="confirmShow"></u-modal>

  </view>
</template>

<script>

import { deptList, visitor} from "@/common/api";

export default {
  name: "index",
  data() {
    return {
      show: false,
      showUid: false,
      showStartTime: false,
      form:{
        startTime:'',
        time:'',
        endTime:'',
        reasons:'',
        vname:'',
        vtel:'',
        vcarNum:'',
        vidNum:'',
        uid:'',
        uName:'',
      },
      rules: {
        time: [{required: true, message: '请选择预约时间', trigger: ['blur', 'change']}],
        uName: [{required: true, message: '请选择预约公司', trigger: ['blur', 'change']}],
        vname: [{required: true, message: '请输入名称', trigger: ['blur', 'change']}],
        vtel: [{required: true, message: '请输入联系电话', trigger: ['blur', 'change']}],
      },
      indexList:[],
      queryParams:{
        pageNum:1,
        pageSize:10,
      },
      load:{
        status: 'loadMore',
        icon: 'flower',
        text:{
          loadmore:'上拉加载',
          loading: '努力加载中',
          nomore: '没有更多数据了'
        }
      },
    }
  },
  onLoad(){
    uni.setNavigationBarTitle({ title: '外部人员预约',});
    this.getCompany();
  },
  onReady() {

    this.$refs.accessForm.setRules(this.rules)
  },
  methods: {
    lower(){
      this.load.status = 'loading';
      this.queryParams.pageNum = this.queryParams.pageNum+ 1;
      this.getCompany();
    },
    submit(){
      this.$refs.accessForm.validate().then(res => {
        visitor(this.form).then(res=>{
          this.show = true;
        })
      })
    },
    getCompany(){
      let _this =this;
      deptList(_this.queryParams).then(res=>{
        if (_this.queryParams.pageNum === 1){
          _this.indexList = res.rows;
        }else{
          _this.indexList.push(...res.rows);
        }
        this.$forceUpdate();
        if (res.haveNextPage && this.queryParams.pageSize === res.rows.length){
          this.load.status = 'loadmore';
        }else{
          this.load.status = 'nomore';
        }
      })
    },
    searchMan(e){
      this.queryParams.pageNum = 1;
      this.getCompany();
    },
    clickKSDataItem(citem){
      this.indexList.map(item =>item['checked'] = false);
      citem['checked'] = true;
      this.form.uid = citem.deptId;
      this.form.uName = citem.deptName;
      this.showUid = false;
      this.$forceUpdate();

    },
    open(){
      let _this = this;
      uni.getSystemInfo({
        success(res) {
          // 获取手机状态栏高度
          let statusBarHeight = res.statusBarHeight;
          _this.scrollviewHeight = `calc(100vh - 480rpx - ${statusBarHeight}rpx)`;
        }
      })

    },
    close(){
      this.showUid = false;
    },
    confirmShow(){
      uni.switchTab({
        url: '/pages/index/index',
      });
    },
    confirmStartTime(e){
      let time = e[0];
      this.form.time = time;
      this.form.startTime = time+ '00:00:00'
      this.form.endTime = time+ '23:59:59'
      this.showStartTime = false;
    }
  },


}
</script>

<style lang="scss" scoped>
@import "@/common/formCommon";
.box-title{
  display: block;
  text-align: center;
  line-height: 52px;
  border-bottom: 1px solid #d6d7d9;
}
.scroll-container{
  width: 100%;
  height: calc(100vh - 170px);
}

.maItem{
  height: 96rpx;
  line-height: 96rpx;
  font-size: 25rpx;
  font-weight: 400;
  color: #000000;
  padding-left: 24rpx;
  &:nth-child(2n+2) {
    border-bottom: 1px solid #E7E7E7;
  }
  &.active{
    background: #e9e9e9;
  }
  &.keyWordInput{
    position: fixed;
    z-index: 9999;
    background: white;
    width: 100%;
    border-bottom: 1px solid #E7E7E7;

  }
}
.bodyItem{
  position: absolute;
  top: 123rpx;
  width: 100%;
}
/deep/.u-close--top-right{
  top: 24rpx;
}
.unLoadMore{
  position: fixed;
  top: 52px;
  width: 100%;
}
.line-height104{
  line-height: 104rpx;
}

</style>
